import { MapPin, Phone, Clock, Mail, Navigation, AlertCircle, MessageCircle } from "lucide-react";
import { brand, locations, openingHours } from "../mock";
import { Button } from "./ui/button";

export default function Locations() {
  const sede = locations[0];
  const mapSrc = `https://www.google.com/maps?q=${encodeURIComponent(brand.mapsQuery)}&output=embed`;

  return (
    <section id="sede" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="max-w-2xl mb-12">
          <span className="text-[#e2001a] font-semibold text-sm uppercase tracking-wide">Dove siamo</span>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl text-[#16181d] mt-2">
            Vieni a trovarci a Treviso
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Map */}
          <div className="rounded-2xl overflow-hidden border border-gray-100 min-h-[360px] shadow-sm">
            <iframe
              title="Mappa AutoItalia Service"
              src={mapSrc}
              width="100%"
              height="100%"
              style={{ minHeight: 360, border: 0 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>

          {/* Info + hours */}
          <div className="space-y-6">
            <div className="bg-[#f5f6f8] rounded-2xl p-6">
              <h3 className="font-display font-bold text-xl text-[#16181d] mb-4">Contatti e indirizzo</h3>
              <ul className="space-y-3 text-[15px]">
                <li className="flex items-start gap-3">
                  <MapPin className="w-5 h-5 text-[#e2001a] mt-0.5" />
                  <span>{sede.address}, {sede.zip}</span>
                </li>
                <li className="flex items-center gap-3">
                  <Phone className="w-5 h-5 text-[#e2001a]" />
                  <a href={brand.phoneHref} className="hover:text-[#e2001a] font-medium">{brand.phone}</a>
                </li>
                <li className="flex items-center gap-3">
                  <AlertCircle className="w-5 h-5 text-[#e2001a]" />
                  <span>Emergenze: <a href={brand.emergencyHref} className="hover:text-[#e2001a] font-medium">{brand.emergency}</a></span>
                </li>
                <li className="flex items-center gap-3">
                  <MessageCircle className="w-5 h-5 text-[#25D366]" />
                  <a href={brand.whatsappHref} target="_blank" rel="noopener noreferrer" className="hover:text-[#25D366] font-medium">WhatsApp: {brand.whatsapp}</a>
                </li>
                <li className="flex items-center gap-3">
                  <Mail className="w-5 h-5 text-[#e2001a]" />
                  <a href={`mailto:${brand.email}`} className="hover:text-[#e2001a]">{brand.email}</a>
                </li>
              </ul>
              <a href={`https://www.google.com/maps?q=${encodeURIComponent(brand.mapsQuery)}`} target="_blank" rel="noopener noreferrer">
                <Button className="mt-5 rounded-full bg-[#e2001a] hover:bg-[#c00016]">
                  <Navigation className="w-4 h-4 mr-2" /> Come raggiungerci
                </Button>
              </a>
            </div>

            <div className="bg-white border border-gray-100 rounded-2xl p-6">
              <div className="flex items-center gap-2 mb-4">
                <Clock className="w-5 h-5 text-[#e2001a]" />
                <h3 className="font-display font-bold text-xl text-[#16181d]">Orari di apertura</h3>
              </div>
              <ul className="divide-y divide-gray-100">
                {openingHours.map((o) => (
                  <li key={o.day} className="flex items-center justify-between py-2 text-sm">
                    <span className="text-gray-600">{o.day}</span>
                    <span className={`font-medium ${o.closed ? "text-gray-400" : "text-[#16181d]"}`}>{o.hours}</span>
                  </li>
                ))}
              </ul>
              <p className="text-xs text-gray-400 mt-3">* Orari indicativi. Ti consigliamo di chiamare per confermare la disponibilità.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
